<template>
  <div style="height: 100%;overflow-x: auto">
    <a-card title="商品信息"  :bordered="false">
      <a-table :columns="columns" :pagination="false" :data-source="datasource"  :scroll="{ x: 1350,y: 500 }">
        <template slot="p_name" slot-scope="text, record">
          <div class="info">
            <img :src="record.imgurl" width="60" height="60" alt="">
            <span>{{record.p_name}}</span>
          </div>

        </template>
      </a-table>
      <div class="bottom">
        <div class="bottomItem">
          <span>优惠金额：</span>
          <p>¥{{datasource[0].after_discount}}</p>
        </div>
        <div class="bottomItem">
          <span>合计支付：</span>
          <p>¥{{datasource[0].total}}</p>
        </div>


      </div>
    </a-card>
    <div class="background"></div>
    <a-card title="申请信息" :bordered="false">
      <div class="sqInfo">
        <ul class="ul">
          <li>
            <label>退款类型：</label>
            <span>{{datasource[0].re_type == 1 ? '退货退款' : datasource[0].re_type == 2 ? '仅退款' : '换货'}}</span>
          </li>
          <li>
            <label>退款金额：</label>
            <span>{{datasource[0].re_apply_money}}</span>
          </li>
          <li>
            <label>申请时间：</label>
            <span>{{datasource[0].re_time}}</span>
          </li>
        </ul>
        <ul class="ul2">
          <li>
            <label>退款类型：</label>
            <span>{{datasource[0].re_time}}</span>
          </li>
          <li>
            <label>退款凭证：</label>
            <span>
              <img v-viewer v-for="(item,index) in imgs" :src="item" width="60" height="60" alt="" />
            </span>
          </li>
        </ul>
        <ul class="ul3">
          <li>
            <label>订单编号：</label>
            <span>{{datasource[0].sNo}}</span>
          </li>

        </ul>
      </div>
    </a-card>
    <div class="background"></div>
    <a-card title="审核记录" :bordered="false">
      <a-row>
        <a-col :span="24">
          <label>审核结果：</label>
          <span>{{datasource[0].r_type}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>实退金额：</label>
          <span>{{datasource[0].real_money}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>审核时间：</label>
          <span>{{datasource[0].audit_time}}</span>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
export default {
name: "Refund",
  data () {
    return {
      columns: [],
      datasource: [],
      id: '',
      detail: '',
      imgs: []
    }
  },
  mounted() {
    this.columns = [
      {
        title: "商品名称",
        key: "p_name",
        dataIndex: "p_name",
        align: 'center',
        scopedSlots: { customRender: "p_name" },
        width: 200
      },
      {
        title: "商品编号",
        key: "pid",
        dataIndex: "pid",
        align: 'center',
      },
      {
        title: "规格",
        key: "size",
        dataIndex: "size",
        align: 'center',
      },
      {
        title: "单价",
        key: "p_price",
        dataIndex: "p_price",
        align: 'center',
      },
      {
        title: "数量",
        key: "num",
        dataIndex: "num",
        align: 'center',
      },
      {
        title: "运费",
        key: "freight",
        dataIndex: "freight",
        align: 'center',
      },
      {
        title: "小计",
        key: "z_price",
        dataIndex: "z_price",
        align: 'center',
      },

    ]
    this.id = this.$route.query.id
    this._axios()
  },
  methods: {
    _axios() {
      let data = {
        id: this.id
      }
      let url = '?module=pc_api&action=ReturnGoods&m=view'
      this.$request.post(url,data).then(res => {
        this.datasource = res.list
        this.imgs = res.imgs
        let r_type = ''
        if (res.list[0].r_type == 0) {
          r_type = '待审核'
        } else if (res.list[0].r_type == 1) {
          r_type = '退换中'
        }else if (res.list[0].r_type == 3) {
          r_type = '退换中'
        }else if (res.list[0].r_type == 11) {
          r_type = '退换成功'
        }else if (res.list[0].r_type == 5) {
          r_type = '退换失败'
        }else if (res.list[0].r_type == 4) {
          r_type = '退款成功'
        }else if (res.list[0].r_type == 9) {
          r_type = '退款成功'
        }else if (res.list[0].r_type == 12) {
          r_type = '换货成功'
        }else if (res.list[0].r_type == 8 && res.list[0].r_content == '已收货') {
          r_type = '退换成功'
        }else if (res.list[0].r_type == 8  && res.list[0].r_content != '已收货') {
          r_type = '退款失败'
        }else {
          r_type = '待审核'
        }
        this.datasource[0].r_type = r_type
      })
    }
  }
}
</script>

<style lang="less" scoped>
ul li {
  list-style: none;
}
.sqInfo {
  display: flex;
}
.ul {
  padding: 0!important;
}
.ul,.ul2,.ul3 {
  display: flex;
  flex-direction: column;
  li {
    margin-bottom: 50px;
  }
}
.ul2 ,.ul3{
  margin-left: 150px;
}
.background {
  height: 10px;
  background: #ecedf3;
}
.info {
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
    text-align: left;
  }
}
label {
  color: #888F9E;
  font-size: 14px;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
  .bottomItem {
    display: flex;
    margin-left: 20px;
    p {
      font-size: 14px;
      font-weight: bold;
      color: #414658;
    }
    span {
      font-size: 14px;
      font-weight: bold;
      color: #EA5A5A;
    }
  }
}
/deep/ .ant-card {
  height: auto;
}
/deep/ .ant-row {
  margin-bottom: 25px;
}
/deep/ .ant-card-body {
  padding: 24px!important;
}
/deep/ .ant-table td {
  white-space:inherit!important;
}
</style>